import React from 'react';

import {ROUTES} from '../config';

import Events from '../containers/events';

import BackToLink from './back-to';
import ImageWithText from './image-with-text';
import LinkWithText from './link-with-text';

const isMacLike = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);

function createNavigationLink(name, coordinates) {
	return isMacLike
		? `https://maps.apple.com/?daddr=${coordinates[1]},${
				coordinates[0]
		  }&ll=${coordinates[1]},${coordinates[0]}&q=${encodeURIComponent(
				name
		  )}`
		: `https://www.google.com/maps/dir/?api=1&destination=${coordinates[1]},${coordinates[0]}`;
}

const Details = ({feature}) => {
	if (!feature) {
		return <div>404</div>;
	}

	const {
		name,
		street,
		number,
		description,
		image,
		image_text: imageText,
		web,
		events,
	} = feature.properties;
	const {coordinates} = feature.geometry;

	return (
		<div className="bsknacht17-content__inner-wrapper">
			<div className="bsknacht17-details">
				<BackToLink backPath={ROUTES.LIST.path}>
					<h2 className="bsknacht17-details__headline">{name}</h2>
				</BackToLink>

				<div className="bsknacht17-details__description">
					{street} {number}
				</div>

				<div className="bsknacht17-details__more">
					{description && (
						<div dangerouslySetInnerHTML={{__html: description}} />
					)}

					{image ? (
						<ImageWithText
							image={image}
							text={imageText}
							prefixClassName={(className) =>
								`bsknacht17-details__${className}`
							}
						/>
					) : null}

					{web ? (
						<p>
							<LinkWithText
								target="_blank"
								rel="external"
								link={web}
								textFallback="Zur Website des Orts"
							/>
						</p>
					) : null}

					{coordinates ? (
						<p>
							<a
								href={createNavigationLink(name, coordinates)}
								target="_blank"
								rel="external"
							>
								Ort in Navigations-App öffnen
							</a>
						</p>
					) : null}
				</div>

				<Events events={events} feature={feature} isExpanded={true} />
			</div>
		</div>
	);
};

export default Details;
